import axios from 'axios';
import { infoStore, ParticipationStatus } from '../store/infoStore';
import { useCallback } from 'react';
import { createBaseParams, getApiEndPoint } from '../utils';
import { modalStore } from '../store/modalStore';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const eventBase = `${getApiEndPoint()}/api-gateway`;
const API_URL = {
  eventInfo: `${eventBase}/nhapi/tnmt/event`,
  qrHash: `${eventBase}/nhapi/tnmt/event/hash`,
  getTicket: `${eventBase}/neapi/tnmt/event/ticket`,
  agreePrivacy: `${eventBase}/nhapi/tnmt/event/agree`,
  usedTicket: `${eventBase}/nhapi/tnmt/event/pass`,
};

const ENTRY_GROUP_SRL = 17;

export const useApiHook = () => {
  const { setInfo } = infoStore();
  const { showPrivacyModal } = modalStore();

  const getEventInfo = useCallback(() => {
    // setInfo({
    //   status: ParticipationStatus.CHECK_ELIGIBLE,
    //   ticketCnt: 100,
    //   userTicketInfo: [
    //     {
    //       ticketNo: 11,
    //       usedYn: 'N',
    //     },
    //     {
    //       ticketNo: 15,
    //       usedYn: 'Y',
    //     },
    //   ],
    //   ticketUseYn: 'Y',
    //   ticketPassword: '1234',
    // });

    axios
      .post(API_URL.eventInfo, createBaseParams(ENTRY_GROUP_SRL))
      .then((response) => {
        setInfo(response.data.data);
        return response.data.data;
      })
      .catch((e) => {
        // alert('에러가 발생 했습니다. 잠시 후 다시 시도해 주세요.');
        console.log(e);
        setInfo({
          status: 3,
          ticketCnt: 0,
        });
      });
  }, [setInfo, showPrivacyModal]);

  const ticketUse = async (ticketNumber: number) => {
    try {
      const response = await axios.post(
        API_URL.usedTicket,
        createBaseParams(ENTRY_GROUP_SRL, ticketNumber),
      );

      return response.data.data;
    } catch (e) {
      alert('에러가 발생 했습니다. 잠시 후 다시 시도해 주세요.');
      console.log(e);
    }
  };
  return { getEventInfo, ticketUse };
};
